import { useState } from "react";
import "./ProjectHeader.css";
import { useAuth } from "../../Context/UserContext";

function ProjectHeader({ setToggleProjectDetails }) {
  const [currentProjectActiveBtn, setCurrentProjectActiveBtn] =
    useState("overview");

  const { userRole } = useAuth();
  return (
    <div className="isecurion_single_project_header_list">
      <button
        className={
          currentProjectActiveBtn === "overview"
            ? "isecurion_single_project_header_active_list"
            : ""
        }
        onClick={() => {
          setToggleProjectDetails("overview");
          setCurrentProjectActiveBtn("overview");
        }}
      >
        Overview
      </button>
      <button
        className={
          currentProjectActiveBtn === "scope"
            ? "isecurion_single_project_header_active_list"
            : ""
        }
        onClick={() => {
          setToggleProjectDetails("scope");
          setCurrentProjectActiveBtn("scope");
        }}
      >
        Scope
      </button>
      <button
        className={
          currentProjectActiveBtn === "vulnerabilities"
            ? "isecurion_single_project_header_active_list"
            : ""
        }
        onClick={() => {
          setToggleProjectDetails("vulnerabilities");
          setCurrentProjectActiveBtn("vulnerabilities");
        }}
      >
        Vulnerabilities
      </button>
      {userRole === "manager" && (
          <button
            className={
              currentProjectActiveBtn === "team"
                ? "isecurion_single_project_header_active_list"
                : ""
            }
            onClick={() => {
              setToggleProjectDetails("team");
              setCurrentProjectActiveBtn("team");
            }}
          >
            Team
          </button>
      )}
      {userRole === "manager" && window.location.pathname.startsWith('/projects') && (
        <button
            className={
              currentProjectActiveBtn === "reports"
                ? "isecurion_single_project_header_active_list"
                : ""
            }
            onClick={() => {
              setToggleProjectDetails("reports");
              setCurrentProjectActiveBtn("reports");
            }}
          >
            Reports
          </button>
      )}
    </div>
  );
}

export default ProjectHeader;